import React from 'react'

export default function NoPage() {
    return (
        <div className='py-5'>
            <div className="container">
                <div className="row">
                    <div className="col">
                        <h1 className="mb-0 text-center">ERROR 404!</h1>
                        <h2 className="mb-0 text-center">Page Not Found</h2>
                    </div>
                </div>
            </div>
        </div>
    )
}